import React, { useCallback, useEffect, useState } from "react";
import { Container } from "reactstrap";
import { useParams } from "react-router-dom";
import PageLoadingSpinner from "components/common/PageLoader";
import BreadCrumb from "components/common/BreadCrumb";
import { getDocumentTitle } from "utils/helpers";
import { getClientAdvance } from "features/ClientAdvances/services/ClientAdvanceService";
import type { ClientAdvance } from "features/ClientAdvances/types/client-advance.types";
import ClientAdvanceOverviewContext from "./ClientAdvanceOverviewContext";
import Section from "./Section";

const ClientAdvanceOverview = () => {
  document.title = getDocumentTitle("Client Advance Details");
  const { id } = useParams();

  const [advance, setAdvance] = useState<ClientAdvance | null>(null);
  const [loading, setLoading] = useState(true);

  const refetch = useCallback(async () => {
    if (!id) return;
    const numericId = Number(id);
    try {
      const res = await getClientAdvance(numericId);
      if (res.success) {
        setAdvance(res.data);
      } else {
        setAdvance(null);
      }
    } catch (err) {
      console.warn(err);
      setAdvance(null);
    }
  }, [id]);

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      if (!id) {
        setLoading(false);
        return;
      }
      setLoading(true);
      await refetch();
      if (!cancelled) setLoading(false);
    };

    void load();
    return () => {
      cancelled = true;
    };
  }, [id, refetch]);

  if (loading) return <PageLoadingSpinner message="Loading advance…" />;

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb
          title="Client Advance Details"
          pageTitle="Finance"
          items={[{ label: "Client Advances", path: "/finance/client-advances" }]}
        />
        <ClientAdvanceOverviewContext.Provider value={{ advance, refetch }}>
          <Section />
        </ClientAdvanceOverviewContext.Provider>
      </Container>
    </div>
  );
};

export default ClientAdvanceOverview;
